import React, { useEffect, useState } from "react";
import { Form, Input, Button, message } from "antd";
import AuthLayout from ".";
import Arrowicon from "../../Assets/Images/Svg/Arrow.svg";
import { useHistory } from "react-router-dom";
import { Base64 } from "js-base64";
import AuthService from "../../Services/AuthService";
import { APP_ROUTES } from "../../PageRouting/approutes";
import { UserSwitchOutlined } from "@ant-design/icons";
import { generateAesKey } from "../../utils/passwordEncrypt";
import Humanimg from "../../Assets/Images/Svg/Loglogo.svg";
import Lock from "../../Assets/Images/Svg/LoginLock.svg";
import openeye from "../../Assets/Images/Svg/eyeopen.svg";
import closeye from "../../Assets/Images/Svg/eyeclose.svg";
import { getFcmToken } from "../../config/firebase";
import { useDispatch } from "react-redux";
import { clearLoggedUser, saveLoggedUser } from "../../Redux/actions/UserActions";

function LoginForm() {
  const [form] = Form.useForm();
  const history = useHistory();
  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [disable, setDisable] = useState(false);
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const dispatch = useDispatch();

  // On initial mount clear savedUser data.
  useEffect(() => {
    dispatch(clearLoggedUser(null));
  }, []);

  const handleLogin = async () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!userName) {
      setError("Please enter User ID or Email");
      return;
    }

    setDisable(true);
    let payload = {
      password: Base64.encode(password),
      userId: isNaN(userName) ? userName : `U${userName}`,
    };

    if (!payload.userId || !payload.password) {
      message.error("please enter valid credentials to login");
      setDisable(false);
      return;
    }

    try {
      const res = await AuthService.TokenAuthentication(payload);
      sessionStorage.setItem("access_token", res.data.access_token);
      sessionStorage.setItem("refresh_token", res.data.refresh_token);
      if (res.data.error === "1") {
        message.error(res.data.error_description);
        setDisable(false);
        return;
      }
      const encryptedPass = generateAesKey(password);
      let data1 = {
        currentVal: encryptedPass,
        userCode: userName,
      };
      const loginResult = await AuthService.Login(data1);
      await saveToken();

      if (!loginResult.data.message) {
        if (
          loginResult.data.user.rolecode !== "SUPERADMIN" &&
          loginResult.data.user.userType == "P"
        ) {
          sessionStorage.setItem(
            "login_result",
            JSON.stringify(loginResult.data)
          );
          dispatch(saveLoggedUser(loginResult.data));
          sessionStorage.setItem(
            "defaultClinic",
            loginResult?.data?.user?.clinic_Id
          );
          history.push(APP_ROUTES.DASHBOARD);
          message.success(
            `Welcome ${loginResult.data.user.firstName} ${loginResult.data.user.lastName}`
          );
        } else {
          message.error("Invalid Credentials, verify and try again");
          setDisable(false);
        }
      } else {
        message.error(loginResult.data.message);
        setDisable(false);
      }
    } catch (error) {
      message.error("An Error occured. Please Try Again");
      setDisable(false);
    }
  };

  const saveToken = async () => {
    const token = await getFcmToken();
    if (token) {
      // store token in your backend / Firestore under user's document
      sessionStorage.setItem('msgToken', token);
    }
  };

  const handleForgotPassword = () => {
    history.push(APP_ROUTES.FORGETPASSWORD, { userName: userName });
  };
  return (
    <AuthLayout>
      <div className="w-[80%]">
        <div className="w-full justify-start flex mt-6">
          <div className="w-[100%]">
            <Form
              name="basic"
              layout="vertical"
              autoComplete="off"
              form={form}
              onFinish={handleLogin}
            >
              <Form.Item name="userId">
                <div className="relative w-full">
                  <input
                    id="username"
                    type="text"
                    value={userName}
                    onChange={(e) => setUserName(e.target.value)}
                    onClick={(e) => setEmail(e.target.value)}
                    placeholder=" "
                    className={`h-10 py-2 w-full px-10 border  rounded focus:outline-none  focus:border-blue-600 peer focus:ring-0`}
                  />
                  <img
                    src={Humanimg}
                    alt="user"
                    className="absolute left-2 top-2 w-6 h-6 object-contain"
                  />
                  <label
                    htmlFor="username"
                    className="absolute left-7 rounded-md  -top-3 text-gray-400 text-[12px] transition-all peer-placeholder-shown:top-3 
                     peer-placeholder-shown:text-[12px] peer-placeholder-shown:text-gray-400 peer-focus:top-[-13px] 
                      bg-white px-1"
                  >
                    User ID or Mobile Number
                  </label>
                  <p className="text-start text-red-500">{error}</p>
                </div>
              </Form.Item>
              <Form.Item name="password" style={{ marginBottom: "1px" }}>
                <div className="relative w-full mt-3">
                  <Input
                    id="password"
                    type={showPassword ? "text" : "password"}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder=" "
                    className={`h-10 py-2 w-full px-10 border  rounded focus:outline-none focus:border-[#189FAA] peer focus:ring-0`}
                  />
                  <img
                    src={Lock}
                    alt="user"
                    className="absolute left-3 top-3 w-4 h-4 object-contain"
                  />
                  <img
                    src={showPassword ? openeye : closeye}
                    alt="user"
                    className="absolute right-3 top-3 w-4 h-4 object-contain"
                    onClick={() => setShowPassword(!showPassword)}
                  />

                  <label
                    htmlFor="password"
                    className="absolute left-7 rounded-md -top-3 text-gray-400 text-[12px] transition-all peer-placeholder-shown:top-3 
                     peer-placeholder-shown:text-[13px]  peer-placeholder-shown:text-gray-400 peer-focus:top-[-13px] 
                       bg-white  px-1"
                  >
                    Password
                  </label>
                </div>
              </Form.Item>
              <div className="text-end   w-full">
                <span
                  onClick={handleForgotPassword}
                  className=" inline-block  text-brand-primaryColor text-xs cursor-pointer "
                >
                  Forgot Password?
                </span>
              </div>
              <Form.Item>
                <button
                  htmlType="submit"
                  type="primary"
                  className="w-full font-semibold text-white rounded-md inline-block mt-5 mb-5 h-10 bg-brand-primaryColor"
                  disabled={disable}
                >
                  Login
                </button>
                <p
                  onClick={() => history.push(APP_ROUTES.MOBILELOGIN)}
                  className=" text-brand-primaryColor text-center   text-xs cursor-pointer mb-3"
                >
                  Login with mobile number
                </p>
                {/* <p className="text-center">Don't have an account?<span className="text-blue-500">Sign up</span> </p> */}
              </Form.Item>
            </Form>
          </div>
        </div>
      </div>
    </AuthLayout>
  );
}

export default LoginForm;
